import * as React from 'react';
import { TranscriptionStatusFilter } from '../../../../../extViewmodels';
import { ISelectOption } from '../../../../../web/components/DeprecatedSelect';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../../../../../web/components-v2/Select';
import { styleSheet } from './styles';

interface IProps {
	disabled?: boolean;
	onChange?: (item: ISelectOption<TranscriptionStatusFilter>) => void;
	selected?: ISelectOption<string>;
}

const options: ISelectOption<TranscriptionStatusFilter>[] = [
	{
		dataContext: null,
		id: 'all',
		text: 'All Statuses',
	},
	{
		dataContext: TranscriptionStatusFilter.TranscriptionComplete,
		id: TranscriptionStatusFilter.TranscriptionComplete,
		text: 'Transcribed',
	},
];

export const TranscriptionStatusSelect: React.FC<IProps> = ({ disabled, onChange, selected }) => {
	const selectedOption = options.find(x => x.dataContext === selected?.dataContext) || options[0];

	return (
		<Select
			disabled={disabled}
			value={selectedOption?.id}
			onValueChange={id => {
				const option = options.find(o => o.id === id);
				if (option) onChange?.(option);
			}}
		>
			<SelectTrigger styles={styleSheet.select}>
				<span>{selectedOption?.text ?? 'Select...'}</span>
			</SelectTrigger>
			<SelectContent styles={styleSheet.selectDropdown}>
				{options.map(option => (
					<SelectItem key={option.id} value={option.id} styles={styleSheet.selectItem}>
						{option.text}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
